export default __webpack_public_path__ + "static/media/mechanician.0e21c91f.jpeg";